<template>
  <tr>
    <td>
      {{ transactionLimit.transaction_limit_id }}
    </td>
    <td>
      {{ entitiesById[transactionLimit.entity_id].text }}
    </td>
    <td>
      {{ transactionLimit.type }}
    </td>
    <td>
      {{ transactionLimit.min_limit }}
    </td>
    <td>
      {{ transactionLimit.max_limit }}
    </td>
    <td>
      {{ transactionLimit.daily_limit }}
    </td>
    <td>
      {{ transactionLimit.weekly_limit }}
    </td>
    <td>
      {{ transactionLimit.monthly_limit }}
    </td>
    <td class="actions">
      <v-icon @click="$emit('edit')">
        edit
      </v-icon>
      <v-icon @click="$emit('delete')">delete</v-icon>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    transactionLimit: {
      type: Object,
      default: () => ({})
    },
    entitiesById: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['edit']
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  gap: 0.5rem;
}
</style>
